/* eslint-disable */

/**
 * Dependencies:
 * - Custom select component
 *
 * Required translation strings:
 * - addToCart
 * - noStock
 * - noVariant
 * - onlyXLeft
 */

if (!customElements.get('variant-picker')) {
  class VariantPicker extends HTMLElement {
    constructor() {
      super();
      this.isBundleParent = this.dataset.isBundleParent === "true"
      this.relevantBundles = theme.relevantBundles;
      this.section = this.closest('.js-product');
      this.productForm = this.section.querySelector('.js-product-form-main');
      this.addBtn = this.productForm ? this.productForm.querySelector('[name="add"]') : null;
      this.optionSelectors = this.querySelectorAll('.option-selector');
      this.inputs = this.querySelectorAll(".js-option");
      this.data = this.getProductData();
      this.proPriceEl = this.section.querySelector('.js-pro-price');
      this.setInitialVariant();
      this.optionsModal = null;
      this.mobileSelectors = this.querySelectorAll(".opt-label--select");
      this.mobileListenersActive = false;
      this.setSelectedOptionLabels(this.inputs);
      this.mobileResize = this.mobileResizeListener.bind(this);
      this.primaryOptionName = this.getPrimaryOptionName();
      this.primaryOptionValuesWithFrom = this.dataset.primaryOptionValuesWithFrom?.split(",") || [];
      this.optionValuesWithGiftLabel = this.getOptionValuesWithGiftLabel();

      this.addEventListener('on:variant:load', this.handleVariantChange.bind(this));
      this.addEventListener('change', this.handleVariantChange.bind(this));

      // Defer these to allow for quick-add modal to full initialize
      if (this.addBtn) {
        setTimeout(() => {
          this.updateAvailability();
          this.updateAddToCartButton();
        });
      }

      if (this.mobileSelectors.length) {
        this.optionsModal = document.getElementById("options-modal");

        if (matchMedia("(max-width: 767px)").matches) {
          this.addMobileListeners();
        }
        
        addEventListener("resize", () => {
          if (this.mobileListenersActive && matchMedia("(min-width: 768px)").matches) {
            this.removeMobileListeners();
          } else if (!this.mobileListenersActive && matchMedia("(max-width: 767px)").matches) {
            this.addMobileListeners();
          }
        });
        
        this.optionsModal.addEventListener("click", this.handleModalClick.bind(this));
      }
    }

    setInitialVariant() {
      const params = new URLSearchParams(document.location.search);
      const variantId = params.get("variant");
      
      if (variantId) {
        const foundVariant = this.data.product.variants.find(variant => variant.id === Number(variantId));

        if (foundVariant) {
          this.variant = this.getVariantWithData(foundVariant);
          this.selectedOptions = this.variant.options;
          this.selectCurrentVariant();
        } else {
          params.delete('variant');
          this.selectedOptions = this.getSelectedOptions();
          this.variant = this.getSelectedVariant();
          this.selectCurrentVariant();
        }
      } else {
        this.selectedOptions = this.getSelectedOptions();
        this.variant = this.getSelectedVariant();

        this.selectCurrentVariant();
      }

      if (this.variant) {
        // Delay until other components have loaded
        setTimeout(() => {
          this.dispatchEvent(new CustomEvent('on:variant:load', {
            bubbles: true,
            detail: {
              form: this.productForm,
              variant: this.variant,
              product: this.data.product
            }
          }), 500);
        })
      }
    }

    handleModalClick(e) {
      if (e.target.id === "options-modal") {
        this.hideOptionsModal();
      }
    }

    handleModalOptionClick(e) {
      const clicked = e.target;

      if (!clicked || clicked.dataset.unavailable === "true") return;

      const clickedId = clicked.getAttribute("for");
      
      if (clickedId) {
        const nextInput = this.querySelector(`input#${clickedId}`);
        const modalSelectorButtons = clicked.closest(".option-selector__btns");
        const prevSelected = modalSelectorButtons.querySelector(`[data-selected="true"]`);
        
        if (nextInput) {
          const selectorButtons = nextInput.closest(".option-selector__btns");
          const prevItem = selectorButtons.querySelector('[data-visible="true"]');

          if (prevItem) {
            prevItem.removeAttribute("data-visible");
            prevItem.querySelector("input").removeAttribute("checked");
          }

          nextInput.checked = "true";
          nextInput.closest(".js-opt-wrapper").dataset.visible = "true";
          clicked.dataset.selected = "true";
          
          this.selectedOptions = this.getSelectedOptions();
          this.variant = this.getSelectedVariant();
          this.hideOptionsModal();
        }

        if (prevSelected) {
          prevSelected.removeAttribute("data-selected");
        }

        this.setSelectedOptionLabels([nextInput]);

        this.dispatchEvent(new CustomEvent('change'));
      }
    }

    updateMobileOptionVisibility() {
      if (!this.mobileListenersActive) return

      this.selectedOptions = this.getSelectedOptions();

      this.inputs.forEach(input => {
        const isSelected = this.selectedOptions.includes(input.value);

        if (isSelected) {
          const parentContainer = input.closest('.js-opt-wrapper');
          const selectorButtons = input.closest(".option-selector__btns");
          const prevItem = selectorButtons.querySelector('[data-visible="true"]');

          
          if (prevItem) {
            prevItem.dataset.visible = "false";
            prevItem.querySelector("input").removeAttribute("checked");
          }

          input.checked = "true";
          parentContainer.dataset.visible = "true";
        }
      });
    }

    showOptionsModal(clickedEl) {
      const selectorButtons = clickedEl.closest(".option-selector__btns");
      const buttons = selectorButtons.querySelectorAll("label");

      buttons.forEach(button => {
        const cloned = button.cloneNode(true);
        const secondaryEl = cloned.querySelector('.opt-label__secondary');
        const label = secondaryEl?.dataset.label || null;
        const unavailable = cloned.querySelector('[data-unavailable]');

        if (label === "Out Of Stock") {
          cloned.dataset.oos = "true";
        }

        if (unavailable) {
          cloned.dataset.unavailable = "true";
        }

        cloned.classList.remove("opt-label--select");
        cloned.removeChild(cloned.querySelector(".opt-label__chevron"));

        if (clickedEl.getAttribute("for") === cloned.getAttribute("for")) {
          cloned.dataset.selected = "true";
        }

        this.optionsModal.querySelector(".option-selector__btns").appendChild(cloned);

        cloned.addEventListener("click", this.handleModalOptionClick.bind(this));
      });

      this.optionsModal.dataset.visible = "true";
      document.body.dataset.fixed = "true";
    }

    hideOptionsModal() {
      document.body.dataset.fixed = "false";
      this.optionsModal.dataset.visible = "false";

      setTimeout(() => {
        this.optionsModal.querySelector(".option-selector__btns").innerHTML = "";
      }, 200);
    }

    addMobileListeners() {
      this.mobileListenersActive = true;

      this.mobileSelectors.forEach(selector => {
        selector.addEventListener("click", this.mobileResize);
      });

      // Make sure selected option is visible
      const selectors = this.querySelector('[mobile-selectors]');
      const visibleSelector = selectors.querySelector('[data-visible="true"]');
      const visibleInput = visibleSelector?.querySelector('input:checked');

      if (visibleInput) return;

      const checkedInput = selectors.querySelector(`input:checked`);
      
      if (checkedInput && visibleSelector) {
        visibleSelector.dataset.visible = "false";
        checkedInput.closest(".js-opt-wrapper").dataset.visible = "true";
      }
    }

    removeMobileListeners() {
      this.mobileListenersActive = false;
      this.hideOptionsModal();

      
      this.mobileSelectors.forEach(selector => {
        selector.removeEventListener("click", this.mobileResize);
      });
    }

    mobileResizeListener(e) {
      this.showOptionsModal(e.target);
    }

    setSelectedOptionLabels(inputs) {
      inputs.forEach(input => {
        if (!input.checked) return;
        
        const container = input.closest('.option-selector');
        const optionLabelEl = container.querySelector('[data-selected-option]');
        const clearanceLabelEl = container.querySelector('[data-selected-clearance-option]');
        const isClearance = input.dataset.clearance === "true";
        
        if (optionLabelEl) {
          optionLabelEl.innerHTML = isClearance ? 'None selected' : input.value;
        }

        if (clearanceLabelEl) {
          clearanceLabelEl.innerHTML = isClearance ? input.value : 'None selected';
        }
      })
    }

    /**
     * Handles 'change' events on the variant picker element.
     * @param {object} e - Event object.
     */
    handleVariantChange(e) {
      const isPrimary = this.primaryOptionName ? e.target.dataset.optionName === this.primaryOptionName : true;
      const optionSelector = e.target.closest(".option-selector");
      this.selectedOptions = this.getSelectedOptions();
      this.variant = this.getSelectedVariant(isPrimary && this.selectedOptions.length > 1, Number(optionSelector?.dataset.selectorIndex || 0));
      
      if (!this.variant && this.selectedOptions?.length > 1 && isPrimary) {
        const firstValid = this.data.product.variants.find(v => v.options.includes(e.target.value));
        
        if (firstValid) {
          this.variant = this.getVariantWithData(firstValid);
        }
      }

      if (this.variant) {
        this.selectCurrentVariant();
        this.updateMedia();
        this.updateUrl(e);
        this.updateVariantInput();
      }

      if (this.addBtn) {
        this.updateAddToCartButton();
      }
      this.updateAvailability();
      this.updatePrice();
      this.updateProPrice();
      this.updateWeight();
      this.updateBarcode();
      this.updateBackorderText();
      this.updatePickupAvailability();
      this.updateSku();
      this.updateMetafieldVisibility();
      VariantPicker.updateLabelText(e);

      this.setSelectedOptionLabels(this.inputs);
      this.updateMobileOptionVisibility();

      if (e.type !== 'on:variant:load') {
        this.dispatchEvent(new CustomEvent('on:variant:change', {
          bubbles: true,
          detail: {
            form: this.productForm,
            variant: this.variant,
            product: this.data.product
          }
        }));
      }

      // Events for bundle parent handled in bundle-children.js
      if (!this.isBundleParent) {
        gg.sendEvent({
          type: gg.eventTypes.PRODUCT_VIEW,
          product: this.data.product,
          variants: [{
            id: this.variant.id,
            compare_at_price: this.variant.compare_at_price,
            price: this.variant.price,
            sku: this.variant.sku,
            title: this.variant.title
          }]
        });
      }
    }

    /**
     * Shows/hides variant metafield elements on the page as necessary
     */
    updateMetafieldVisibility() {
      document.querySelectorAll('[data-variant-metafield]').forEach((elem) => {
        elem.classList.toggle('hidden', elem.dataset.variantMetafield !== this.variant?.id.toString());
      });
    }

    /**
     * Updates the "Add to Cart" button label and disabled state.
     */
    updateAddToCartButton() {
      if (!this.productForm) return;

      // Stacks handled in "bundle-children" component
      if (this.isSelectedVariantAStack()) return;
      
      const variantAvailable = this.variant && this.variant.isAvailable;
      const variantData = this.variant ? this.data.formatted[this.variant.id] : null;
      const isPreorder = !!variantData?.preorderShippingMessage || !!this.data.preorderShippingMessage || false;
      const addToCartText = isPreorder ? "Pre-order" : this.addBtn.dataset.addToCartText;

      this.addBtn.disabled = !variantAvailable;

      const unavailableStr = this.variant ? theme.strings.noStock : theme.strings.noVariant;
      const textContainer = this.addBtn.querySelector('.js-atc-text');
      const textContent = variantAvailable ? addToCartText : unavailableStr;

      
      if (textContainer) {
        textContainer.textContent = textContent;
      } else {
        this.addBtn.textContent = textContent;
      }
    }

    getPrimaryOptionName() {
      const options = this.data.product.options;

      if (!options) return null;

      return options.includes("Size") ? "Size" : options[0];
    }

    getShowPrice({ hasMultipleOptions, isPrimaryOption, priceVaries }) {
      if (!hasMultipleOptions && priceVaries) return true;
      if (hasMultipleOptions) {
        if (isPrimaryOption) return true;

        const primaryOptionHasFrom = this.primaryOptionValuesWithFrom.reduce((acc, cur) => {
          return acc || this.selectedOptions.includes(cur.trim());
        }, false);        

        return primaryOptionHasFrom;
      }
      
      return false;
    }

    /**
     * Updates the availability status of an option.
     * @param {Element} optionEl - Option element.
     * @param {boolean} exists - Does this option lead to a variant that exists?
     * @param {boolean} available - Does this option lead to a variant that is available to buy?
     */
    updateOptionAvailabilityAndPrice(optionEl, exists, available, price = null) {
      const isPrimaryOption = this.primaryOptionName ? optionEl.dataset.optionName === this.primaryOptionName : true;
      const hasMultipleOptions = this.selectedOptions && this.selectedOptions.length > 1;
      const showPrice = this.getShowPrice({
        hasMultipleOptions,
        isPrimaryOption,
        priceVaries: optionEl.dataset.priceVaries === "true"
      });
      const labelEl = optionEl.nextElementSibling;
      const primaryEl = labelEl.querySelector('.opt-label__primary');
      const secondaryEl = labelEl.querySelector('.opt-label__secondary');
      const priceEl = primaryEl.querySelector('.opt-label__price');

      if (exists) {
        optionEl.removeAttribute("disabled");
        optionEl.classList.remove('is-nonexistent');
        primaryEl.removeAttribute('data-unavailable');

        if (!isPrimaryOption || !hasMultipleOptions) {
          if (showPrice) {
            priceEl.innerHTML = price ? `$${(price * 0.01).toFixed(2)}` : "";
          } else {
            priceEl.innerHTML = "";
          }
        }

        if (optionEl.value !== 'DECLINE') {
          if (available) {
            const label = labelEl.dataset.label;
            const showGiftLabel = this.optionValuesWithGiftLabel.includes(optionEl.value);

            if (showGiftLabel) {
              secondaryEl.setAttribute('data-label', "Free Gift");
              secondaryEl.classList.add('opt-label__secondary--highlight');
            } else {
              if (label) {
                secondaryEl.setAttribute('data-label', label);
              } else {
                secondaryEl.removeAttribute('data-label');
              }

              secondaryEl.classList.remove('opt-label__secondary--highlight');
            }
            optionEl.classList.remove('is-oos');
          } else {
            optionEl.classList.add('is-oos');
            secondaryEl.setAttribute('data-label', "Out Of Stock");
            secondaryEl.classList.remove('opt-label__secondary--highlight');
          }
        }
      } else {
        optionEl.disabled = true;
        optionEl.classList.add('is-nonexistent');
        primaryEl.setAttribute('data-unavailable', "");
        secondaryEl.removeAttribute('data-label');

        if (showPrice) {
          primaryEl.setAttribute('data-show-price', "");
        } else {
          primaryEl.removeAttribute('data-show-price');
        }
      }
    }

    /**
     * Updates the availability status in option selectors.
     */
    updateAvailability() {
      let currVariant = this.variant || { options: this.getSelectedOptions() };

      // Set initial availability states
      const hasMultipleOptions = this.selectedOptions && this.selectedOptions.length > 1;
      this.inputs.forEach((input) => {
        const isPrimary = input.dataset.optionName === this.primaryOptionName
        const markAsAvailable = (hasMultipleOptions && isPrimary) || input.value === 'DECLINE'
        const exists = markAsAvailable || !hasMultipleOptions;
        this.updateOptionAvailabilityAndPrice(input, exists, markAsAvailable);
      });

      // Flag selector options as available or sold out, depending on the variant availability
      this.optionSelectors.forEach((selector) => {
        const selectorIndex = Number(selector.dataset.selectorIndex);
        const isPrimary = selector.dataset.optionName === this.primaryOptionName
        
        if (!isPrimary || !hasMultipleOptions) {
          this.data.product.variants.forEach((variant) => {
            let matchCount = 0;

            variant.options.forEach((option, optionIndex) => {
              const matches = currVariant.options.includes(option);

              if (matches && optionIndex !== selectorIndex) {
                matchCount += 1;
              }
            });

            if (matchCount === currVariant.options.length - 1) {
              const options = selector.querySelectorAll('.js-option');

              const optionEl = Array.from(options).find((opt) => {
                return opt.value === variant.options[selectorIndex];
              });

              if (optionEl) {
                const variantWithData = this.getVariantWithData(variant);
                this.updateOptionAvailabilityAndPrice(optionEl, true, variantWithData.isAvailable, variant.price);
              }
            }
          })
        }
      });
    }

    /**
     * Updates the backorder text and visibility.
     */
    updateBackorderText() {
      this.backorder = this.backorder || this.section.querySelector('.backorder');
      if (!this.backorder) return;

      let hideBackorder = true;

      if (this.variant && this.variant.available) {
        const { inventory } = this.data.formatted[this.variant.id];

        if (this.variant.inventory_management && inventory === 'none') {
          const backorderProdEl = this.backorder.querySelector('.backorder__product');
          const prodTitleEl = this.section.querySelector('.product-title');
          const variantTitle = this.variant.title.includes('Default')
            ? ''
            : ` - ${this.variant.title}`;

          backorderProdEl.textContent = `${prodTitleEl.textContent}${variantTitle}`;
          hideBackorder = false;
        }
      }

      this.backorder.hidden = hideBackorder;
    }

    /**
     * Updates the color option label text.
     * @param {object} evt - Event object
     */
    static updateLabelText(evt) {
      const selector = evt.target.closest('.option-selector');
  
      if (!selector) return;
      if (selector.dataset.selectorType === 'dropdown') return;

      const colorText = selector.querySelector('.js-color-text');
      if (!colorText) return;

      colorText.textContent = evt.target.nextElementSibling.querySelector('.js-value').textContent;
    }

    /**
     * Updates the product media.
     */
    updateMedia() {
      /*
        If any variants of a product have a bundle, the image update is handled in "bundle-children" component
      */
      if (this.isBundleParent && this.variant && this.data.bundleImages[this.variant.id]) return;

      if (!this.variant.featured_media) return;

      if (this.section.matches('quick-add-drawer')) {
        this.section.updateMedia(this.variant.featured_media.id);
      } else {
        this.mediaGallery = this.mediaGallery || this.section.querySelector('media-gallery');

        if (!this.mediaGallery) return;

        const variantMedia = this.mediaGallery.querySelector(
          `[data-media-id="${this.variant.featured_media.id}"]`
        );
        this.mediaGallery.setActiveMedia(variantMedia, true, true);
      }
    }

    /**
     * Updates the pick up availability.
     */
    updatePickupAvailability() {
      this.pickUpAvailability =
        this.pickUpAvailability || this.section.querySelector('pickup-availability-link');
      if (typeof this.pickUpAvailability?.getAvailability !== 'function') return;

      if (this.variant) {
        this.pickUpAvailability.getAvailability(this.variant.id);
      } else {
        this.pickUpAvailability.innerHTML = '';
      }
    }

    /**
     * Updates the price.
     */
    updatePrice() {
      this.price = this.price || this.section.querySelector('.product-info__price > .price');
      if (!this.price) return;

      if (this.variant) {
        const priceCurrentEl = this.price.querySelector('.price__current');
        const priceWasEl = this.price.querySelector('.price__was');
        const unitPriceEl = this.price.querySelector('.unit-price');
        const atcButtonPriceEl = this.addBtn ? this.addBtn.querySelector('.js-atc-price') : null;
        const isOnSale = this.variant.compare_at_price > this.variant.price;

        // Update current price
        priceCurrentEl.innerHTML = this.data.formatted[this.variant.id].price;

        if (atcButtonPriceEl) {
          atcButtonPriceEl.textContent = " - " + this.data.formatted[this.variant.id].price;
        }

        // Update original price if on sale
        if (priceWasEl) {
          priceWasEl.innerHTML = this.data.formatted[this.variant.id].compareAtPrice || '';
        }

        // Update unit price, if specified.
        if (this.variant.unit_price_measurement) {
          const valueEl = this.price.querySelector('.unit-price__price');
          const unitEl = this.price.querySelector('.unit-price__unit');
          const value = this.variant.unit_price_measurement.reference_value;
          const unit = this.variant.unit_price_measurement.reference_unit;

          valueEl.innerHTML = this.data.formatted[this.variant.id].unitPrice;
          unitEl.textContent = value === 1 ? unit : `${value} ${unit}`;
        }

        unitPriceEl.hidden = !this.variant.unit_price_measurement;
        this.price.classList.toggle('price--on-sale', isOnSale);
        priceCurrentEl.classList.toggle('price__current--sale', isOnSale);
        this.price.classList.toggle('price--sold-out', !this.variant.available);
      }

      this.price.querySelector('.price__default').hidden = !this.variant;
      this.price.querySelector('.price__no-variant').hidden = this.variant;
      const from = this.price.querySelector('.price__from');
      if (from) {
        from.hidden = true;
      }
    }

    updateProPrice() {
      const proPrice = this.getProPrice();

      if (this.proPriceEl) {
        this.proPriceEl.innerHTML = `$${gg.toMoney(proPrice / 100)}`;
      }
    }

    getOptionValuesWithGiftLabel() {
      if (!theme.relevantBundles?.length) return [];
      
      const allOptionsHaveGifts = theme.relevantBundles.some(b => {
        if (b.parent.vids?.length) return false;
        
        return b.type === "G" || b.configs.some(c => c.type === "G");
      });

      if (allOptionsHaveGifts) return [];

      let valuesWithGiftLabel = [];

      this.inputs.forEach(input => {
        const isPrimary = this.primaryOptionName ? input.dataset.optionName === this.primaryOptionName : true;

        if (isPrimary) {          
          const hasMatch = this.data.product.variants.reduce((acc, cur) => {
            if (!cur.options.includes(input.value)) return acc;

            const match = theme.relevantBundles.find(b => {
              if (!b.configs?.some(c => c.type === "G")) return false;
              if (!b.parent.vids) return true;
              
              return b.parent.vids.includes(String(cur.id));
            });
            
            return acc || !!match;
          }, false);

          if (hasMatch) {
            valuesWithGiftLabel.push(input.value);
          }
        }
      });
      
      return valuesWithGiftLabel;
    }

    getProPrice() {
      function findMatchingProConfig({ productId, vendor }, proConfigs) {
        return proConfigs?.find(c => {
          if ('pid' in c && c.pid === productId) return true
          if ('vendor' in c && c.vendor === vendor) return true
      
          return false
        })
      }

      function getMultiplerFromPercent(percent) {
        return 1 - percent * 0.01
      }

      function round(val, decimalPlaces = 2) {
        return parseFloat(val.toFixed(decimalPlaces))
      }

      const { pro } = window.theme;

      if (!pro?.settings || !pro?.configs || !this.variant) return null;

      const price = this.variant.price;
      const compareAt = this.variant.compare_at_price;
      const isOnSale = !!compareAt && price < compareAt;
      const difference = isOnSale ? compareAt - price : 0;
      const percentageDiscount = isOnSale ? Number(((difference / compareAt) * 100).toFixed(0)) : 0;
      const proConfig = findMatchingProConfig({ productId: String(this.data.product.id), vendor: this.data.product.vendor }, pro.configs);
    
      if (proConfig?.type === "fixedPrice") {
        const configPrice = Number(proConfig.val*100);
    
        // take a further 5% off the price if the current price is within 5% of the configured fixed price
        const threshold = round(configPrice / 0.95);
    
        return price <= threshold ? round(price * 0.95) : configPrice;
      }
    
      if (proConfig?.type === "percentage") {
        const configPercent = Number(proConfig.val);
    
        const multiplier = getMultiplerFromPercent(configPercent);
        const discountedPrice = (compareAt || price) * multiplier;
    
        // take a further 5% off if the current discount percentage is within 5% the configured percentage discount, making sure that it's at least as much as the discountedPrice
        if (percentageDiscount >= configPercent - 5) {
          const adjustedPrice = round(price * 0.95);
          return adjustedPrice < discountedPrice ? adjustedPrice : discountedPrice;
        }
    
        return discountedPrice
      }

      if (this.isSelectedVariantAStack()) return price;

      const fullDiscountMultiplier = getMultiplerFromPercent(pro.settings.fullPriceDiscountPercent);
      const saleDiscountMultiplier = getMultiplerFromPercent(pro.settings.salePriceDiscountPercent);
    
      if (!isOnSale) return price * fullDiscountMultiplier;
    
      /* 
        - if less than saleThresholdPercent discount take fullPricePercent off compareAt (original price)
        - else if saleThresholdPercent or more discount take a further salePricePercent off price (discounted price)
      */
    
      return percentageDiscount >= pro.settings.saleThresholdPercent
        ? price * saleDiscountMultiplier
        : compareAt * fullDiscountMultiplier;
    }

    /**
     * Updates the weight.
     */
    updateWeight() {
      this.weights = this.weights || this.section.querySelectorAll('.product-info__weight');
      if (this.weights.length === 0) return;

      const weightAvailable = this.variant && this.variant.weight > 0;
      this.weights.forEach((weight) => {
        weight.textContent = weightAvailable ? this.data.formatted[this.variant.id].weight : '';
        weight.hidden = !weightAvailable;
      });
    }

    /**
     * Updates the Barcode.
     */
    updateBarcode() {
      this.barcodes = this.barcodes || this.section.querySelectorAll('.product-info__barcode-value');
      if (this.barcodes.length === 0) return;

      const barcodeAvailable = this.variant && this.variant.barcode;
      this.barcodes.forEach((barcode) => {
        barcode.textContent = barcodeAvailable ? this.variant.barcode : '';
        barcode.parentNode.hidden = !barcodeAvailable;
      });
    }

    /**
     * Updates the SKU.
     */
    updateSku() {
      this.sku = this.sku || this.section.querySelector('.product-sku__value');
      if (!this.sku) return;

      const skuAvailable = this.variant && this.variant.sku;
      this.sku.textContent = skuAvailable ? this.variant.sku : '';
      this.sku.parentNode.hidden = !skuAvailable;
    }

    /**
     * Updates the url with the selected variant id.
     * @param {object} evt - Event object.
     */
    updateUrl(evt) {
      if (!evt || evt.type !== 'change' || this.dataset.updateUrl === 'false') return;
      window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.variant.id}`);
    }

    /**
     * Updates the value of the hidden [name="id"] form inputs.
     */
    updateVariantInput() {
      this.forms =
        this.forms || this.section.querySelectorAll('.js-product-form-main, .js-instalments-form');

      this.forms.forEach((form) => {
        const input = form.querySelector('input[name="id"]');
        const inputBinLocations = form.querySelector('input[name="bin-locations"]');
        
        input.value = this.variant.id;

        if (inputBinLocations) {
          const variantData = this.data.formatted[this.variant.id];
          const binLocations = variantData && variantData.binLocations || "";
          inputBinLocations.value = binLocations;
        }
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }

    /**
     * Gets the selected option element from each selector.
     * @returns {Array}
     */
    getSelectedOptions() {
      const selectedOptions = [];

      this.optionSelectors.forEach((selector) => {
        if (selector.dataset.selectorType === 'dropdown') {
          const selectedText = selector.querySelector('.custom-select__btn').textContent.trim();
          selectedOptions.push(selectedText === this.dataset.placeholderText ? null : selectedText);
        } else {
          const selected = selector.querySelector('input:checked');
          selectedOptions.push(selected ? selected.value : null);
        }
      });

      return selectedOptions;
    }

    /**
     * Gets the product data.
     * @returns {?object}
     */
    getProductData() {
      const dataEl = this.querySelector('[type="application/json"]');
      return JSON.parse(dataEl.textContent);
    }

    /**
     * Get selected variant data.
     * @returns {?object} Variant object, or null if one is not selected.
     */
    getSelectedVariant(primaryOptionChanged = false, optionIndex = 0) {
      const variant = this.data.product.variants.find(
        (v) => v.options.every((val) => this.selectedOptions.includes(val))
      );

      if (!variant && primaryOptionChanged && this.selectedOptions.length) {
        const sorted = this.data.product.variants.sort((a, b) => { 
          let isClearanceA = false;
          let isClearanceB = false;

          for (const item of this.data.validation.clearance) {
            if (a.title.toLowerCase().includes(item)) {
              isClearanceA = true;
            }

            if (b.title.toLowerCase().includes(item)) {
              isClearanceB = true;
            }
          }

          if (isClearanceA && !isClearanceB) return 1;
          if (!isClearanceA && isClearanceB) return -1;
          return 0;
        })
        const foundAvailableVariant = sorted.find(v => v[`option${optionIndex + 1}`] === this.selectedOptions[optionIndex] && v.available);
        const foundVariant = foundAvailableVariant || sorted.find(v => v[`option${optionIndex + 1}`] === this.selectedOptions[optionIndex]);

        return foundVariant ? this.getVariantWithData(foundVariant) : this.getVariantWithData(this.data.product.variants[0]);
      }

      return this.getVariantWithData(variant);
    }

    getVariantWithData(variant) {
      const variantData = this.data.formatted[variant.id];
      const continueSelling = variantData?.inventoryPolicy === 'continue';
      const oosOnline = variantData?.stockStatus === 'Out of stock';
      const isAvailable = variant.available && (continueSelling || !oosOnline)

      return variantData ? {  ...variantData, ...variant, isAvailable } : variant;
    }

    isSelectedVariantAStack() {
      const visibleBundleChildren = document.querySelectorAll('.js-bundle-child-wrapper[data-visible="true"]');

      if (visibleBundleChildren.length) {
        let isStack = false;
        
        for (const el of visibleBundleChildren) {
          if (el.dataset.bundleType === 'S') {
            isStack = true;
          }
        }

        return isStack;
      }

      return false
    }

    selectCurrentVariant() {
      this.optionSelectors.forEach((selector, i) => {
        const current = selector.querySelector('input:checked');

        if (current) {
          current.checked = false;
        }

        const next = selector.querySelector(`input[value="${this.variant[`option${i + 1}`]}"]`);

        if (next) {
          next.checked = true;
        }
      })
    }
  }

  customElements.define('variant-picker', VariantPicker);
}